import $ from 'jquery'

function init() {}
function ready() {
  if (!$('html').hasClass('page-function')) {
    return
  }

  var areas = ['business', 'operation', 'corporate', 'op-and-bs']

  areas.forEach(function (area) {
    var $targetImg = $(`.js-figure_${area}`)
    $(`.js-hover_${area}`).on('mouseenter', function () {
      $targetImg.addClass('is-active')
    })
    $(`.js-hover_${area}`).on('mouseleave', function () {
      $targetImg.removeClass('is-active')
    })
    $(`.js-hover_${area}`).on('focus', function () {
      $targetImg.addClass('is-active')
    })
    $(`.js-hover_${area}`).on('blur', function () {
      $targetImg.removeClass('is-active')
    })
  })
}

export default {
  init() {
    init()
    $(function () {
      ready()
    })
  },
}
